<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  export default {
    data () {
      return {
        
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      
    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: 'announcement',

          // SINGLE
          single: false,

          // CHECKBOX
          checkbox: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Judul',
              width: '200px',
              value: 'announcement_title',
              freeze: false,
              hide: false
            },
            {
              text: 'Deskripsi',
              width: '700px',
              value: 'announcement_content',
              freeze: false,
              hide: false,
              format: 'regex'
            },
            {
              text: 'Dibuat Oleh',
              width: '200px',
              value: 'announcement_author_fullname',
              freeze: false,
              hide: false
            },
            {
              text: 'Status',
              width: '100px',
              value: 'announcement_status',
              freeze: false,
              hide: false
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // PREFIX KEY
          prefix: 'announcement_',

          // CONFIG PARSING FORM
          form: [
            {
              field: 'id',
              label: 'ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: '',
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'title',
              label: 'Judul',
              type: 'text',
              placeholder: 'Contoh. Libur Nasional',
              value: '',
              width: '70%',
              required: true,
              rules: 'required'
            },
            {
              field: 'content',
              label: 'Deskripsi',
              type: 'texteditor',
              placeholder: 'Contoh. Tuliskan deskripsi disini',
              value: '',
              rows: 5,
              required: false
            },
            {
              field: 'status',
              label: 'Status',
              type: 'select',
              placeholder: 'Contoh. Publish',
              value: '',
              option: [
                {
                  text: 'Publish',
                  value: 'publish'
                },
                {
                  text: 'Draft',
                  value: 'draft'
                }
              ],
              width: '40%',
              required: false
            }
          ],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: true,
              api: 'announcement/create',
              window: false,
              href: ''
            },
            edit: {
              button: true,
              api: 'announcement/update',
              window: false,
              href: ''
            },
            delete: {
              button: true,
              api: 'announcement/delete'
            },
            detail: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: false,
              api: ''
            },
            hide: {
              button: false,
              api: ''
            }
          }
        }
      }
    }
  }
</script>